import { render, staticRenderFns } from "./VotingRegistrationSubmissions.vue?vue&type=template&id=07d61b5c&"
import script from "./VotingRegistrationSubmissions.vue?vue&type=script&lang=js&"
export * from "./VotingRegistrationSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./VotingRegistrationSubmissions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports